import { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import { useCertificateUploadForm } from './hooks/use-certificate-upload-form';
import { CertificateFormStep } from './steps/certificate-form-step';
import { EmailFormStep } from '../../../common/email-form-step/email-form-step';

export const UploadCertificateForm = () => {
  const { form, onSubmit } = useCertificateUploadForm();
  const [step, setStep] = useState<'certificate' | 'email'>('email');

  const handleNextStep = () => {
    setStep('certificate');
  };

  return (
    <FormProvider {...form}>
      <StyledForm onSubmit={form.handleSubmit(onSubmit)} noValidate>
        {step === 'email' ? (
          <EmailFormStep onSuccess={handleNextStep} verified />
        ) : (
          <CertificateFormStep />
        )}
      </StyledForm>
    </FormProvider>
  );
};

const StyledForm = styled('form')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});
